import { Button, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLoaderData } from 'react-router-dom';

import type { IDeviceUpdate } from '../types';
import type { DeviceLoaderType } from '../queries';

import { useDeviceQuery, useDeviceUpdate } from '../queries';
import { useValidation } from '@/hooks/useValidation';
import { routes } from '@/app/router/routes';

import { FormCommon } from './FormCommon';
import { PageHeader } from '@/ui/PageHeader';
import { Loading } from '@/ui/Loading';

export const DeviceUpdate = (): JSX.Element => {
  const { t } = useTranslation();
  const [form] = Form.useForm<IDeviceUpdate>();
  const { validate } = useValidation();
  const initialData = useLoaderData() as DeviceLoaderType;
  const { data: device, isLoading: isLoadingQuery } = useDeviceQuery(initialData);
  const { mutate: deviceUpdate, isLoading: isLoadingMutation } = useDeviceUpdate();

  const submitHandler = (data: IDeviceUpdate) => {
    deviceUpdate(data);
  };

  return (
    <>
      <PageHeader
        title={t('devices.form.updateTitle')}
        description={t('devices.form.updateDescription')}
        navigateBackUrl={routes.devices()}
      />
      <Loading loading={isLoadingQuery}>
        <Form
          name='deviceUpdate'
          form={form}
          initialValues={device}
          requiredMark='optional'
          layout='vertical'
          onFinish={submitHandler}
          scrollToFirstError
        >
          <Form.Item name='id' rules={validate('required')} hidden>
            <Input />
          </Form.Item>

          <FormCommon />

          <Form.Item>
            <Button type='primary' htmlType='submit' loading={isLoadingMutation}>
              {t('global.save')}
            </Button>
          </Form.Item>
        </Form>
      </Loading>
    </>
  );
};
